module.exports = __webpack_public_path__ + "./fonts/BoschSans-Regular.ttf";